const pre = '/carbon/';

export default {
    path: '/carbon',
    title: '碳行中国',
    header: '',
    icon: 'md-stats',
    children: [
        {
            path: `${pre}integral`,
            title: '碳积分 - 青碳行'
        },
        {
            path: `${pre}exchange`,
            title: '兑换 - 青碳行'
        },
        {
            path: `${pre}wallet`,
            title: '钱包 - 青碳行'
        },
        {
            path: `${pre}bubble`,
            title: '气泡 - 青碳行'
        },
        {
            path: `${pre}integral-sh`,
            title: '碳积分 - 沪碳行'
        },
        {
            path: `${pre}exchange-sh`,
            title: '兑换 - 沪碳行'
        },
        {
            path: `${pre}wallet-sh`,
            title: '钱包 - 沪碳行'
        },
        {
            path: `${pre}bubble-sh`,
            title: '气泡 - 沪碳行'
        }
    ]
}